import {computed, effect, EffectCleanupRegisterFn, inject, Injectable, signal} from "@angular/core";
import {ParticipantDeviceService, TypePredicates} from "@services";
import {ExamApplicationData} from "@models";

@Injectable()
export class ClinicalVignetteTimerService {
	private _participantDeviceService = inject(ParticipantDeviceService);

	private _currentTime = signal(Date.now());

	constructor() {
		effect((onCleanup) => this._currentTimeEffect(onCleanup));
	}

	public remainingTimeClinicalVignette = computed<number | null>(() => {
		return this._calculateRemainingTime(
			this._participantDeviceService.examState(),
			this._participantDeviceService.phaseStartTimeAdjusted()?.getTime(),
			this._currentTime(),
		);
	});

	private _currentTimeEffect(onCleanup: EffectCleanupRegisterFn) {
		const interval = setInterval(() => {
			this._currentTime.set(Date.now());
		}, 250);

		onCleanup(() => clearInterval(interval));
	}

	/*
	 * Calculate the remaining time for the clinical vignette
	 * Returns null if the clinical vignette is not active
	 * Otherwise, returns the remaining time in seconds
	 */
	private _calculateRemainingTime(
		data: ExamApplicationData | null,
		phaseStartTimeMs: number | undefined,
		currentTimeMs: number,
	): number | null {
		if (
			!TypePredicates.isExamRunApplicationData(data) ||
			!TypePredicates.isExamRunEncounterApplicationData(data) ||
			!phaseStartTimeMs
		) {
			return null;
		}

		const clinicalVignetteEndTimeMs = phaseStartTimeMs + data.clinicalVignetteDurationInSeconds * 1000;

		if (clinicalVignetteEndTimeMs < currentTimeMs) {
			return null;
		}

		return Math.max(0, Math.ceil((clinicalVignetteEndTimeMs - currentTimeMs) / 1000));
	}
}
